import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { establecerPasswordPropia, logoutUser } from '../db/engine';
import { Shield, Eye, EyeOff } from 'lucide-react';
import { problemaClave, REGLA_CLAVE } from '../utils/clave';

// Pantalla que aparece en el PRIMER ingreso (o tras un reseteo del master), cuando
// el usuario todavía tiene una contraseña temporal. Lo obliga a definir una propia
// antes de entrar al sistema. No se puede saltar: la única salida es cambiarla o salir.
export default function CambioObligatorio() {
  const { user, refrescarPerfil, logout } = useApp();
  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const [ver, setVer] = useState(false);
  const [msg, setMsg] = useState('');
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    setMsg('');
    const problema = problemaClave(p1);
    if (problema) return setMsg(problema);
    if (p1 !== p2) return setMsg('Las dos contraseñas no coinciden.');
    setGuardando(true);
    const r = await establecerPasswordPropia(p1);
    if (!r.ok) { setMsg('Error: ' + r.error); setGuardando(false); return; }
    await refrescarPerfil();   // apaga esta pantalla y entra al sistema
  };

  const salir = async () => { await logoutUser(); await logout(); };

  return (
    <div className="login-container" style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh' }}>
      <div className="login-card" style={{ maxWidth: 440, width:'100%' }}>
        <div style={{ textAlign:'center', marginBottom:8 }}>
          <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(var(--sky-rgb),0.15)', display:'inline-flex', alignItems:'center', justifyContent:'center', marginBottom:12 }}>
            <Shield size={26} style={{ color:'var(--sky-light)' }} />
          </div>
          <h2 style={{ margin:0, color:'var(--text)' }}>Crea tu contraseña</h2>
          <p style={{ color:'var(--silver)', fontSize:13, marginTop:6 }}>
            {user?.nombre ? `${user.nombre}, ` : ''}esta es tu primera entrada. Por seguridad,
            define una contraseña personal antes de continuar.
          </p>
        </div>

        <form onSubmit={guardar}>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'var(--silver)', marginBottom:6 }}>Nueva contraseña</label>
            <div style={{ position:'relative' }}>
              <input type={ver ? 'text' : 'password'} value={p1} onChange={e=>setP1(e.target.value)} autoFocus
                autoComplete="new-password" placeholder={REGLA_CLAVE.charAt(0).toUpperCase() + REGLA_CLAVE.slice(1)}
                style={{ width:'100%', padding:'12px 40px 12px 16px', background:'rgba(var(--navy-rgb),0.6)', border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:8, fontSize:14, color:'var(--text)', fontFamily:'var(--font)', outline:'none' }} />
              <button type="button" onClick={()=>setVer(v=>!v)}
                style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--silver)', display:'flex' }}>
                {ver ? <EyeOff size={18}/> : <Eye size={18}/>}
              </button>
            </div>
          </div>

          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'var(--silver)', marginBottom:6 }}>Repite la contraseña</label>
            <input type={ver ? 'text' : 'password'} value={p2} onChange={e=>setP2(e.target.value)}
              autoComplete="new-password" placeholder="La misma de arriba"
              style={{ width:'100%', padding:'12px 16px', background:'rgba(var(--navy-rgb),0.6)', border:'1px solid rgba(var(--silver-rgb),0.2)', borderRadius:8, fontSize:14, color:'var(--text)', fontFamily:'var(--font)', outline:'none' }} />
          </div>

          {msg && <div style={{ fontSize:13, color: msg.startsWith('Error') || msg.includes('coinciden') || msg.includes('caracteres') ? '#ef4444' : '#22c55e', marginBottom:12 }}>{msg}</div>}

          <button type="submit" disabled={guardando} className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'12px' }}>
            {guardando ? 'Guardando...' : 'Guardar y entrar'}
          </button>
        </form>

        <button onClick={salir} style={{ display:'block', margin:'14px auto 0', background:'none', border:'none', color:'var(--silver)', fontSize:12, cursor:'pointer', textDecoration:'underline' }}>
          Cancelar y salir
        </button>
      </div>
    </div>
  );
}
